import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class InteractionEndpointsService {
  readonly #service = inject(ServicesService);

  public attempt() {
    return this.#service.thorEndpoint(`attempt`);
  }

  public draft() {
    return this.#service.thorEndpoint(`draft`);
  }

  public selfScore() {
    return this.#service.thorEndpoint(`self-score`);
  }

  public close(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thorEndpoint(
      `attempt/${arrangementCode}/${contentIdentifier}/close`,
    );
  }

  public resultById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thorEndpoint(
      `result/content/${arrangementCode}/${contentIdentifier}`,
    );
  }

  public resultAttemptsById(
    arrangementCode: string,
    contentIdentifier: string,
    userIdentifier?: string,
  ) {
    return this.#service.thorEndpoint(
      `result/content/${arrangementCode}/${contentIdentifier}/${userIdentifier}?allAttempts=true`,
    );
  }

  public clearResultById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thorEndpoint(
      `attempt/${arrangementCode}/${contentIdentifier}/all`,
    );
  }

  public progressById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thorEndpoint(
      `score/content/${arrangementCode}/${contentIdentifier}`,
    );
  }

  public answerById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thorEndpoint(
      `answer/${arrangementCode}/${contentIdentifier}`,
    );
  }

  public startSelfTest() {
    return this.#service.thorEndpoint('sequence/start');
  }

  public submitSelfTest() {
    return this.#service.thorEndpoint('sequence/submit');
  }

  public completeSelfTest() {
    return this.#service.thorEndpoint('sequence/end');
  }

  public deleteSelfTest() {
    return this.#service.thorEndpoint('sequence/delete');
  }
}
